"use client"


import { Phone, MapPin, Mail } from "lucide-react"

const ContactInfo = () => {
    return <div className="space-y-6 text-[#FFF] px-[16px] text-[16px] md:px-0 lg:mt-[30px]">
        <h3 className="font-semibold">Direct</h3>

        <div className="space-y-4">
            <div className="flex items-center space-x-4">
                <Phone className="h-5 w-5 flex-shrink-0" />
                <span className="">+91 92666-13030</span>
            </div>

            <div className="flex items-start space-x-4">
                <MapPin className="h-5 w-5 flex-shrink-0 mt-1" />
                <span className="">237, Okhla Industrial Estate, Phase 3, New Delhi - 110020</span>
            </div>

            <div className="flex items-center space-x-4">
                <Mail className="h-5 w-5 flex-shrink-0" />
                <span className="">contact@zenithratech.com</span>
            </div>
        </div>
    </div>
}
export default ContactInfo;